import { useSyncExternalStore } from "react";
/**
 * D-P3-10 (UI_P3): mobile signal that follows the dock CSS breakpoint exactly.
 *
 * `useViewportBreakpoint` measures `contentRect` (scrollbar excluded), which can
 * disagree with the media query by ~15px and leave the dock pin visible in the
 * mobile sheet. This hook evaluates the same query the stylesheet uses
 * (`@media (max-width: 767px)`), so pin visibility flips with the layout.
 *
 * Browser globals are read as bare identifiers on purpose: `window`/`document`
 * are restricted by lint (`no-restricted-globals`) and counted by
 * `audit:dom-access`. The mql is memoised lazily (identity-aware) so a test stub
 * swap cannot leak a stale MediaQueryList into later mounts; nothing touches the
 * DOM at module import time (SSR contract).
 */
const MOBILE_QUERY = "(max-width: 767px)";
const MOBILE_MAX_WIDTH = 767;
let cachedMql = null;
let cachedMatchMedia = null;
function getMql() {
    if (typeof matchMedia !== "function")
        return null;
    if (!cachedMql || cachedMatchMedia !== matchMedia) {
        cachedMatchMedia = matchMedia;
        cachedMql = matchMedia(MOBILE_QUERY);
    }
    return cachedMql;
}
function readMobile() {
    const mql = getMql();
    if (mql)
        return mql.matches;
    return typeof innerWidth === "number" && innerWidth <= MOBILE_MAX_WIDTH;
}
function subscribe(onChange) {
    const mql = getMql();
    if (!mql)
        return () => { };
    if (typeof mql.addEventListener === "function") {
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }
    // Safari < 14 fallback.
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
}
function getServerSnapshot() {
    return false;
}
export function useMobileViewportMatch() {
    return useSyncExternalStore(subscribe, readMobile, getServerSnapshot);
}
